import React from "react";
import Seo from "../components/molecules/Seo";
// import Gallery from "../components/organisms/Gallery";
import Container from "../components/atoms/Container";
import styled from "styled-components";

const Holder = styled.div`
`;

const About = styled.div`
  margin-top: 4rem;
`;

const IndexPage = () => (
  <Holder>
    <Seo title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Container>
      <p>Contact: hamishmclean89@gmail.com</p>
      <p>Rate: Junior/Mid Developer - $350/day</p>
      <p>Skills: React, CSS, Javascript, Prismic, Netlify, GitHub, OpenAI</p>
      <About>
        <p>
          Hamish is an Australian web developer based in the Blue Mountains,
          west of Sydney. In his former years, he completed a degree in
          Mathematics and Philosophy before spending a decade teaching high
          school Mathematics. After taking a break to write a number of books
          for gifted students, focusing on mathematical and logical thinking
          skills, Hamish decided to become a web developer.
        </p>
        <p>
          He has worked on projects for <a href="https://supermarket.london" target="_blank">Supermarket</a>, University of Technology Sydney, Sydney Review of Books, <a href="https://www.publicwebsites.com" target="_blank">Public Websites</a>, The Brain Cancer Group, and Ezybin amongst others.
        </p>
        <p>
          While Hamish has worked on a small number of projects, they are
          diverse in size and scope. Some are small sites for small businesses.
          Some are large sites for large organisations. For Supermarket,
          he has worked on a number of projects as a mathematical consultant, including one comissioned by a global brand to investigate how it can harness the
          power of AI.
        </p>
      </About>
    </Container>
  </Holder>
);

export default IndexPage;



